export default "__VITE_ASSET__iXnpTfPW__"